import React, { useState, useEffect } from 'react';
import style from "./VrtSession.module.sass";
import ToggleButton from "./ToggleButton";
import { start } from '@popperjs/core';
const SelectButtonEducational = ({ levelName, scenery, presetEducational, sessionParameters, onSelect, onSelectValuesChange,onScenarioChange }) => {  
  const [selectedId, setSelectedId] = useState(null);
  const [selectValues, setSelectValues] = useState({
    code: '',
    time_day: '',
    weather: '',
    sounds: '',
    trafficLights: '',
    crosswalks: '',
    cars: '',
    pedestrians: '',
    image_url: '',
    starting_point: ''
  });

  const [options, setOptions] = useState({
    time_day: [],
    weather: [],
    sounds: [],
    trafficLights: [],
    crosswalks: [],
    cars: [],
    pedestrians: [],
    starting_point: ''
  });

    const [toggleStatuses, setToggleStatuses] = useState({
      caa: sessionParameters?.caa || false,
      dist: sessionParameters?.dist || false,
    });
  

  useEffect(() => {
    if (sessionParameters) {
      console.log(sessionParameters);
      setSelectedId(sessionParameters.selected_preset_id || null);
      let sceneryOptions = scenery.find(s => s.code === sessionParameters.scenery);

      setSelectValues({
        code: sessionParameters.scenery || "",
        time_day: sessionParameters.time_day || "",
        weather: sessionParameters.weather || "",
        sounds: sessionParameters.sounds || "",
        trafficLights: sessionParameters.trafficLights || "",
        crosswalks: sessionParameters.crosswalks || "",
        cars: sessionParameters.cars || "",
        pedestrians: sessionParameters.pedestrians || "",
        image_url: sessionParameters.image_url,
        starting_point: sessionParameters.starting_point,
        dist: sessionParameters.dist || false
      });

      setOptions({
        time_day: sceneryOptions.time_dayOptions || [],
        weather: sceneryOptions.weatherOptions || [],
        sounds: sceneryOptions.soundsOptions || [],
        trafficLights: sceneryOptions.trafficLightsOptions || [],
        crosswalks: sceneryOptions.crosswalksOptions || [],
        cars: sceneryOptions.carsOptions || [],
        pedestrians: sceneryOptions.pedestriansOptions || [],
        starting_point: sceneryOptions.starting_point
      });
    } else if (presetEducational && presetEducational.length > 0) {
      const firstId = presetEducational[0].id;
      setSelectedId(firstId);
      onSelect(firstId);
      updateSelectFields(firstId);
    }
  }, [sessionParameters, presetEducational, onSelect]);

  const handleButtonClick = (e, id) => {
    e.preventDefault();
    setSelectedId(id);
    onSelect(id);
    console.log('Selected ID:', id);
    updateSelectFields(id);
  };

  const updateSelectFields = (id) => {
    const selectedPreset = presetEducational.find(preset => preset.id === id);
    if (selectedPreset) {
      console.log('Selected Preset:', selectedPreset);
      console.log('Selected Preset Code:', selectedPreset.code);
      console.log('Selected interaction:', selectedPreset.interactions_colorsOptions);
      const selectedCode = selectedPreset.code || '';
      const newSelectValues = {
        code: selectedCode,
        time_day: selectedPreset.time_dayOptions || '',
        weather: selectedPreset.weatherOptions || '',
        sounds: selectedPreset.soundsOptions || '',
        trafficLights: scenery.find(s => s.code === selectedCode)?.trafficLightsOptions?.[0] || '',
        crosswalks: scenery.find(s => s.code === selectedCode)?.crosswalksOptions?.[0] || '',
        cars: scenery.find(s => s.code === selectedCode)?.carsOptions?.[0] || '',
        pedestrians: scenery.find(s => s.code === selectedCode)?.pedestriansOptions?.[0] || '',
        image_url: selectedPreset.image_url,
        starting_point: selectedPreset.starting_point,
        dist: selectedPreset.dist || false
      };
      setSelectValues(newSelectValues);
      onSelectValuesChange(newSelectValues);
      updateOptions(selectedCode);
    }
  };

  const updateOptions = (code) => {
    const sceneryOptions = scenery.find(s => s.code === code);
    if (sceneryOptions) {
      setOptions({
        time_day: sceneryOptions.time_dayOptions || [],
        weather: sceneryOptions.weatherOptions || [],
        sounds: sceneryOptions.soundsOptions || [],
        trafficLights: sceneryOptions.trafficLightsOptions || [],
        crosswalks: sceneryOptions.crosswalksOptions || [],
        cars: sceneryOptions.carsOptions || [],
        pedestrians: sceneryOptions.pedestriansOptions || [],
        image_url: sceneryOptions.image_url,
        starting_point: sceneryOptions.starting_point,
        dist: sceneryOptions.dist || false
      });

      setSelectValues(prevValues => ({
        ...prevValues,
        time_day: sceneryOptions.time_dayOptions?.length > 0 ? prevValues.time_day : '',
        weather: sceneryOptions.weatherOptions?.length > 0 ? prevValues.weather : '',
        sounds: sceneryOptions.soundsOptions?.length > 0 ? prevValues.sounds : '',
        trafficLights: sceneryOptions.trafficLightsOptions?.length > 0 ? prevValues.trafficLights : '',
        crosswalks: sceneryOptions.crosswalksOptions?.length > 0 ? prevValues.crosswalks : '',
        cars: sceneryOptions.carsOptions?.length > 0 ? prevValues.cars : '',
        pedestrians: sceneryOptions.pedestriansOptions?.length > 0 ? prevValues.pedestrians : '',
        image_url: sceneryOptions.image_url,
        starting_point: sceneryOptions.starting_point,
        dist: sceneryOptions.dist || false
      }));
    }
  };

  const updateOptionCode = (code) => {
    const sceneryOptions = scenery.find(s => s.code === code);
    if (sceneryOptions) {
      const newOptions = {
        time_day: sceneryOptions.time_dayOptions || [],
        weather: sceneryOptions.weatherOptions || [],
        sounds: sceneryOptions.soundsOptions || [],
        trafficLights: sceneryOptions.trafficLightsOptions || [],
        crosswalks: sceneryOptions.crosswalksOptions || [],
        cars: sceneryOptions.carsOptions || [],
        pedestrians: sceneryOptions.pedestriansOptions || [],
        image_url: sceneryOptions.image_url,
        starting_point: sceneryOptions.starting_point,
        dist: sceneryOptions.dist || false
      };

      setOptions(newOptions);

      const newSelectValues = {
        code,
        image_url: newOptions.image_url,
        time_day: newOptions.time_day.length > 0 ? newOptions.time_day[0] : '',
        weather: newOptions.weather.length > 0 ? newOptions.weather[0] : '',
        sounds: newOptions.sounds.length > 0 ? newOptions.sounds[0] : '',
        trafficLights: newOptions.trafficLights.length > 0 ? newOptions.trafficLights[0] : '',
        crosswalks: newOptions.crosswalks.length > 0 ? newOptions.crosswalks[0] : '',
        cars: newOptions.cars.length > 0 ? newOptions.cars[0] : '',
        pedestrians: newOptions.pedestrians.length > 0 ? newOptions.pedestrians[0] : '',
        starting_point: newOptions.starting_point,
        dist: newOptions.dist || false
        };

        setSelectValues(newSelectValues);
        onSelectValuesChange(newSelectValues);
    }
  };


  const handleToggle = (name, newStatus) => {
    setToggleStatuses((prevStatuses) => ({
      ...prevStatuses,
      [name]: newStatus,
    }));
  
    // Aggiorna anche selectValues per essere sicuri che venga passato al form
    const updatedValues = {
      ...selectValues,
      [name]: newStatus,
    };
  
    setSelectValues(updatedValues);
    onSelectValuesChange(updatedValues);
  };

  const handleSelectChange = (e, selectName) => {
    const value = e.target.value;
    const newSelectValues = {
      ...selectValues,
      [selectName]: value
    };
    
    setSelectValues(newSelectValues);
    onSelectValuesChange(newSelectValues);

    if (selectName === 'code') {
      if (value !== selectValues.code && typeof onScenarioChange === 'function') {
        onScenarioChange(); // notifica che lo scenario è stato cambiato
      }
      updateOptionCode(value);
    }
  };

  return (
    <div className={style.formGroup}>

      <label>Scenario</label>
 
        <select className={style.dropdown} value={selectValues.code} onChange={(e) => handleSelectChange(e, 'code')}>
          {scenery.map(s => (
            <option key={s.code} value={s.code}>
              {s.code}
            </option>
          ))}
        </select>

        <label className={style.starting_point} data-text={options.starting_point} >Posizione di partenza {options.starting_point}</label>

        {options.time_day.length > 0 && <label> Condizioni di luce</label> }

        {options.time_day.length > 0 && (
          <select className={style.dropdown} value={selectValues.time_day} onChange={(e) => handleSelectChange(e, 'time_day')}>
            {options.time_day.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {options.weather.length > 0 &&  <label>Clima</label>}

        {options.weather.length > 0 && (
          <select className={style.dropdown} value={selectValues.weather} onChange={(e) => handleSelectChange(e, 'weather')}>
            {options.weather.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {options.sounds.length > 0 &&  <label>Suoni ambientali e musica</label>}
 
        {options.sounds.length > 0 && (
          <select className={style.dropdown} value={selectValues.sounds} onChange={(e) => handleSelectChange(e, 'sounds')}>
            {options.sounds.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {options.trafficLights.length > 0 &&  <label>Semafori e controllo colore</label>}

        {options.trafficLights.length > 0 && (
          <select className={style.dropdown} value={selectValues.trafficLights} onChange={(e) => handleSelectChange(e, 'trafficLights')}>
            {options.trafficLights.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}


        {options.crosswalks.length > 0 &&  <label>Strisce pedonali</label>}
  
        {options.crosswalks.length > 0 && (
          <select className={style.dropdown} value={selectValues.crosswalks} onChange={(e) => handleSelectChange(e, 'crosswalks')}>
            {options.crosswalks.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {options.cars.length > 0 &&  <label>Preferenze per i veicoli</label>}

        {options.cars.length > 0 && (
          <select className={style.dropdown} value={selectValues.cars} onChange={(e) => handleSelectChange(e, 'cars')}>
            {options.cars.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {options.pedestrians.length > 0 &&  <label>Altri pedoni</label>}

        {options.pedestrians.length > 0 && (
          <select className={style.dropdown} value={selectValues.pedestrians} onChange={(e) => handleSelectChange(e, 'pedestrians')}>
            {options.pedestrians.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

      <div>

      <ToggleButton
        initialStatus={toggleStatuses.dist}
        onToggle={(name, newStatus) => handleToggle(name, newStatus)}
        title="Segnaletica Aumentativa"
        name="dist"
      />
      </div>

    </div>
  );
};

export default SelectButtonEducational;
